// extracted by mini-css-extract-plugin
export default {"mainContainer":"main_mainContainer__bIa+H"};